import type { Empresa } from '@/api/types';

/**
 * Nome principal pra display.
 * Preferência: nome_fantasia > nome.
 * Nome fantasia é o "nome comercial" (Lojas Renner) — mais reconhecível.
 * Nome técnico/razão (Lojas Renner S.A.) vai como secundário.
 */
export function displayName(e: Pick<Empresa, 'nome' | 'nome_fantasia'>): string {
  const f = (e.nome_fantasia ?? '').trim();
  if (f) return f;
  return e.nome;
}

/**
 * Nome secundário (subtítulo). Razão social quando ela é diferente do nome principal.
 * Retorna null quando não há informação adicional útil.
 */
export function secondaryName(
  e: Pick<Empresa, 'nome' | 'nome_fantasia' | 'razao_social'>,
): string | null {
  const principal = displayName(e);
  const r = (e.razao_social ?? '').trim();
  if (!r) return null;
  if (r.toUpperCase() === principal.toUpperCase()) return null;
  return r;
}
